import Cookie from 'js-cookie'

import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [{
    path: '/',
    component: resolve => require(['@/views/index'], resolve)
  }, {
    path: '/manage/',
    meta: {
      requireAuth: true,
      title: '管理后台',
    },
    component: resolve => require(['@/views/manage/index'], resolve),
    children: [{
      path: '/manage/',
      meta: {
        title: '工作平台',
        requireAuth: true
      },
      component: resolve => require(['@/views/manage/home'], resolve)
    }, {
      path: '/manage/member/lists',
      meta: {
        title: '代理管理',
        requireAuth: true
      },
      component: resolve => require(['@/views/manage/member/lists'], resolve)
    },{
      path: '/manage/user/lists',
      meta: {
        title: '现场服务',
        requireAuth: true
      },
      component: resolve => require(['@/views/manage/user/lists'], resolve)
    }, {
      path: '/manage/union/lists',
      meta: {
        title: '合作单位',
        requireAuth: true
      },
      component: resolve => require(['@/views/manage/union/lists'], resolve)
    }, {
      path: '/manage/student/school',
      meta: {
        title: '筛查场次',
        requireAuth: true
      },
      component: resolve => require(['@/views/manage/student/school'], resolve)
    }, {
      path: '/manage/student/grades',
      meta: {
        title: '筛查网点',
        requireAuth: true
      },
      component: resolve => require(['@/views/manage/student/grades'], resolve)
    }, {
      path: '/manage/student/lists',
      meta: {
        title: '检测用户管理',
        requireAuth: true
      },
      component: resolve => require(['@/views/manage/student/lists'], resolve)
    }, {
      path: '/manage/setting/region',
      meta: {
        title: '行政区域',
        requireAuth: true
      },
      component: resolve => require(['@/views/manage/setting/region'], resolve)
    }, {
      path: '/manage/setting/qrcode',
      meta: {
        title: '采血管码',
        requireAuth: true
      },
      component: resolve => require(['@/views/manage/setting/qrcode'], resolve)
    },{
      path: '/manage/admin/lists',
      meta: {
        title: '管理人员',
        requireAuth: true
      },
      component: resolve => require(['@/views/manage/admin/lists'], resolve)
    }, {
      path: '/manage/admin/group',
      meta: {
        title: '管理角色',
        requireAuth: true
      },
      component: resolve => require(['@/views/manage/admin/group'], resolve)
    }, {
      path: '/manage/admin/menu',
      meta: {
        title: '管理权限',
        requireAuth: true
      },
      component: resolve => require(['@/views/manage/admin/menu'], resolve)
    }]
  }]
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 导航守卫
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth == true) { // 判断该路由是否需要登录权限
    if (to.path.indexOf('manage') > 0) {
      let admin = Cookie.get('admin')
      if (admin === undefined || !admin) { // cookie是否存在
        next({
          path: '/' // 跳转到登录界面
        })
      } else {
        next()
      }
    } 
  } else {
    next()
  }
})

export default router